import type { IFormState } from "../Interfaces";

export const getInitialValues = (): IFormState => {
  return {
    title: "",
    description: "",
    attachments: [],
  };
};
